import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
export const baseUrl = "https://backend.gkgallery.com/api/";
export const fileUrl = "https://backend.gkgallery.com/storage/";
//=============================================================> post data login
export const useLOGIN = (initialState) => {
  const [formData, setFormData] = useState(initialState); // data
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (url) => {
    setLoading(true);
    setError("");
    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    axios
      .post(`${baseUrl}${url}`, formDataToSend)
      .then((req) => {
        setLoading(false);
        setError("");
        localStorage.setItem("token", req.data.data.token);
        navigate("/");
      })
      .catch((e) => {
        setError(e.response.data.message);
        setLoading(false);
      });
  };
  //
  return { formData, handleChange, loading, error, handleSubmit };
};
// =============================================================> post data all
export const usePOST = (initialState) => {
  const [formData, setFormData] = useState(initialState); //send  data ==> text , image , video , time , file
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [img, setImg] = useState(""); // viwe image doucment
  const [imgs, setImgs] = useState([]); // viwe images array
  const [imgss, setImgss] = useState([]); // send Array images

  const handleChange = (event) => {
    //function change input everything
    const { name, value, type, files } = event.target;
    const newValue = type === "file" ? files[0] : value; //
    type === "file" && setImg(URL.createObjectURL(newValue));
    let dateTime =
      type === "datetime-local"
        ? value.substring(0, 10) + " " + value.substring(11) + ":00"
        : newValue; //===>,
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "datetime-local" ? dateTime : newValue,
    }));
  };
  const handleChangeArray = (event) => {
    //function change input array images
    const { files } = event.target;
    let inputFiles = files;
    for (let i = 0; i < inputFiles.length; i++) {
      setImgss((prevFiles) => [...prevFiles, inputFiles[i]]);
    }
    const imageUrls = Array.from(inputFiles).map((file) =>
      URL.createObjectURL(file)
    );
    setImgs((prevImageUrls) => [...prevImageUrls, ...imageUrls]);
  };
  /// function post data all
  const handleSubmit = async (url) => {
    setLoading(true);
    setError("");
    const formDataToSend = new FormData();
    for (const [key, value] of Object.entries(formData)) {
      formDataToSend.append(key, value);
    }
    for (let i = 0; i < imgss.length; i++) {
      formDataToSend.append("images[]", imgss[i]);
    }
    axios
      .post(`${baseUrl}${url}`, formDataToSend, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setLoading(false);
        setError("");
        window.history.go(-1);
      })
      .catch((e) => {
        setError(e.response.data.message);
        setLoading(false);
      });
  };
  return {
    formData,
    setFormData,
    handleChange,
    handleChangeArray,
    loading,
    error,
    handleSubmit,
    img,
    setImg,
    imgs,
    setImgs,
    imgss,
    setImgss,
  };
};

//=============================================================> fetch data
export const useFETCH = (url, urlDelete) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isErroe, setIsError] = useState("");
  const naviget = useNavigate();
  useEffect(() => {
    axios
      .get(`${baseUrl}${url}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        if (req) {
          setData(req);
          setIsLoading(false);
          setIsError("");
        }
      })
      .catch((e) => {
        setIsLoading(false);
        setIsError("خطأ في جلب البيانات");

        if (e.request.status === 401) {
          naviget("/login");
          localStorage.clear();
        }
        if (e.request.status === 403) {
          naviget("/403");
        }
        if (e.request.status === 500) {
          naviget("/500");
        }
      });
  }, [url]);

  //=============================================================> pagination
  const handlePageClick = (event) => {
    axios
      .get(`${baseUrl}${url}?page=${event.selected + 1}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setIsLoading(false);
        setData(req);
        return req;
      })
      .catch((e) => "");
  };

  //=============================================================> deleteItem
  const deleteItem = async (e) => {
    setIsLoading(true);
    axios
      .delete(`${baseUrl}${urlDelete || url}/${e.id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((req) => {
        setIsLoading(false);
        setIsError("تم الحذف  بنجاح");
        window.location.reload();
      })
      .catch((e) => {
        setIsLoading(false);
        setIsError(" خطأ في الحذف  حاول مرة آخرى");
      });
  };
  return { data, isLoading, isErroe, deleteItem, handlePageClick };
};

// عدم دخول من غير تسجيل دخول
export const RequireAuth = ({ children }) => {
  if (!window.localStorage.getItem("token")) {
    return <Navigate to="/login" />;
  }
  return children;
};
// عدم فتح صفحة تسجيل دخول اذا مسجل مسيقا
export const RequireLogin = ({ children }) => {
  if (window.localStorage.getItem("token")) {
    return <Navigate to="/" />;
  }
  return children;
};
export const handleClick = (event) => {
  event.target.requestFullscreen();
};
